import React, { useMemo } from 'react';
import { FormikProps } from 'formik';
import { MdArrowBack } from 'react-icons/md';

import FadeIn from 'legacy/common/components/transition/FadeIn';
import Field from 'legacy/common/components/wysiwyg-form/Field';
import { useMultiTierCheckout } from '../../../context';
import { ErrorResponse } from 'legacy/common/utils/error';
import ConfirmButton from './ConfirmButton';

import styles from '../../../../Checkout.module.scss';

type Props = {
  goToTicketSelection: () => void;
  data: ReturnType<
    typeof useMultiTierCheckout
  >['data']['requestScreening']['questions'];
  error: ErrorResponse;
} & FormikProps<unknown>;

const ScreeningForm = ({
  submitForm,
  values,
  goToTicketSelection,
  data,
  error
}: Props) => {
  const totalNumberOfAnswers = useMemo(
    () => Object.values(values).filter((val) => val).length,
    [values]
  );

  return (
    <div className={styles.wrapper}>
      <div className={styles.column}>
        <div className="px-5">
          <FadeIn>
            <div className="relative">
              <div className="absolute -top-8 -left-8 flex items-center">
                <MdArrowBack
                  size="26px"
                  className="text-gray-500 cursor-pointer"
                  onClick={goToTicketSelection}
                />
                <h1 className="title ml-5 mt-1">Screening Questions</h1>
              </div>
              <div className="border-b-1 border-gray-200 mt-3 pt-3 -ml-11 -mr-11" />
            </div>
            <div className="-ml-4 -mr-11 overflow-y-auto pr-6 pt-4 max-h-[82vh] md:max-h-[510px]">
              <div className="font-normal text-sm text-gray-500 pb-4">
                Please answer the following questions to help us review your
                application...
              </div>
              {data.map((item) => (
                <Field
                  key={item._id}
                  type="text"
                  label={item.question}
                  id={`question-${item._id}`}
                  name={item._id}
                  placeholder="Write answer here..."
                />
              ))}
            </div>
            <ConfirmButton
              totalNumberOfAnswers={totalNumberOfAnswers}
              totalNumberOfQuestions={data.length}
              submitForm={submitForm}
              error={error}
            />
          </FadeIn>
        </div>
      </div>
    </div>
  );
};

export default ScreeningForm;
